import { Currency } from "@redotech/money/iso4217/currencies";
import {
  accountIdFormat,
  priceBookEntryIdFormat,
  priceBookIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import { price_book_status } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const PriceBookStatusSchema = createEnum(price_book_status);
export const CurrencySchema = createEnum(Currency, { enumName: "Currency" });

const PriceBookRowSchema_ = z.object({
  id: priceBookIdFormat.schema,
  accountId: accountIdFormat.schema,
  name: z.string(),
  description: z.string(),
  status: PriceBookStatusSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});
export const PriceBookRowSchema: z.ZodType<PriceBookRow> = PriceBookRowSchema_;
export interface PriceBookRow extends z.infer<typeof PriceBookRowSchema_> {}

const PriceBookEntrySchema_ = z.object({
  id: priceBookEntryIdFormat.schema,
  productId: productIdFormat.schema,
  productSku: z.string().nullable(),
  productTitle: z.string().nullable(),
  fixedPrice: z.bigint().nullable(),
  currency: CurrencySchema.nullable(),
});
export const PriceBookEntrySchema: z.ZodType<PriceBookEntry> =
  PriceBookEntrySchema_;
export interface PriceBookEntry extends z.infer<typeof PriceBookEntrySchema_> {}

const PriceBookTableRowSchema_ = PriceBookRowSchema_.extend({
  entryCount: z.number(),
});
export const PriceBookTableRowSchema: z.ZodType<PriceBookTableRow> =
  PriceBookTableRowSchema_;
export interface PriceBookTableRow
  extends z.infer<typeof PriceBookTableRowSchema_> {}

const PriceBookDetailEntrySchema_ = z.object({
  id: priceBookEntryIdFormat.schema,
  productId: productIdFormat.schema,
  productSku: z.string().nullable(),
  productTitle: z.string().nullable(),
  fixedPrice: z.number().nullable(),
  currency: CurrencySchema.nullable(),
  kind: z.string(),
  imageUrl: z.string().nullable(),
});
export const PriceBookDetailEntrySchema: z.ZodType<PriceBookDetailEntry> =
  PriceBookDetailEntrySchema_;
export interface PriceBookDetailEntry
  extends z.infer<typeof PriceBookDetailEntrySchema_> {}

const PriceBookDetailRowSchema_ = PriceBookRowSchema_.extend({
  entries: z.array(PriceBookDetailEntrySchema),
});
export const PriceBookDetailRowSchema: z.ZodType<PriceBookDetailRow> =
  PriceBookDetailRowSchema_;
export interface PriceBookDetailRow
  extends z.infer<typeof PriceBookDetailRowSchema_> {}

export { price_book_status as PriceBookStatus } from "@redotech/redo-prisma-client/enums";

export const priceBookStatusDisplayLabels: Record<price_book_status, string> = {
  ACTIVE: "Active",
  DRAFT: "Draft",
  ARCHIVED: "Archived",
};
